import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=6591acfb&scoped=true"
import script from "./DropdownButton.vue?vue&type=script&lang=js"
export * from "./DropdownButton.vue?vue&type=script&lang=js"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=6591acfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6591acfb",
  null
  
)

export default component.exports